<div class="component">
  <div class="{{uiClasses}}cards" part="cards">
    {{>slot}}
  </div>
</div>
